import axios from "axios";

const parseJwt = (token) => {
    if (!token) { return; }
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
}

const accessControlStrategies = {
    admin: ({ resource, action }) => {
        return true;
    },
    user: ({ resource, action }) => {
        return resource !== 'users';
    },
    reader: ({ resource, action }) => {
        return resource !== 'users' && action === 'read';
    },
}

const authProvider = {
    async login({ username, password }) {
        axios({
            method: "POST",
            url: `${process.env.REACT_APP_API_URL}/login`,
            headers: {
                "Content-Type": "application/json",
            },
            data: {
                email: username,
                password: password,
            },
        })
            .then((res: any) => {
                const webToken = res.data.token;
                localStorage.setItem("token", webToken);
            })
    },
    async checkError(error) {
        const status = error.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            throw new Error('Session expired');
        }
    },
    async checkAuth() {
        if (!localStorage.getItem('token')) {
            throw new Error('Not authenticated');
        }
    },
    async logout() {
        localStorage.removeItem('token');
    },
    async getIdentity() {
        const user = parseJwt(localStorage.getItem("token"));
        return { id: user.username, fullName: user.name };
    },
    async canAccess({ action, resource }) {
        const user = parseJwt(localStorage.getItem("token"));

        if (user && user.roles.includes("ROLE_SUPER_ADMIN")) {
            return true;
        }
        return false
        // return accessControlStrategies[user.email]({ resource, action });
    },
    async getPermissions() {
        const user = parseJwt(localStorage.getItem("token"));
        
        if (user && user.roles.includes("ROLE_SUPER_ADMIN")) {
            return "admin";
        }

        return "user";
    },
};
export default authProvider
